import {snackbarTypes} from "../../util/state/globalVariables";
import {setSnackbar} from "../../util/state/globalAction";
import {EnumInterface} from "./api/types/generic";
import {CommercialSegmentEntityResponse} from "./api/types/commercialSegment";
import {CommercialCategoryEntityResponse} from "./api/types/commercialCategory";
import {ProductCodeEntityResponse} from "./api/types/productCode";

export const CAR_GROUPS = [
    {
        id: 9,
        code: "CDMR",
        carClass: {
            id: 3,
            descr: "Compact",
            carSegment: {
                id: 3,
                descr: "Compact",
                tenant: "drivalia_it",
                order: 3
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat 500 L e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 10,
        code: "CWMR",
        carClass: {
            id: 3,
            descr: "Compact",
            carSegment: {
                id: 3,
                descr: "Compact",
                tenant: "drivalia_it",
                order: 3
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat Tipo SW e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 7,
        code: "ECAE",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat 500 Electric e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 5,
        code: "ECMH",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat Panda Hybrid e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 2,
        code: "ECMR",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat Panda e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 8,
        code: "EDAE",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Opel Corsa Electric e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 6,
        code: "EDMH",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Lancia Y Hybrid e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 4,
        code: "EDMR",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Opel Corsa e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 3,
        code: "ELMR",
        carClass: {
            id: 2,
            descr: "Economy",
            carSegment: {
                id: 2,
                descr: "Economy",
                tenant: "drivalia_it",
                order: 2
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat 500 Abarth e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 19,
        code: "FDAI",
        carClass: {
            id: 6,
            descr: "Full size",
            carSegment: {
                id: 6,
                descr: "Full size",
                tenant: "drivalia_it",
                order: 6
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "DS7 Crossback PHEV o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 21,
        code: "FDAR",
        carClass: {
            id: 6,
            descr: "Full size",
            carSegment: {
                id: 6,
                descr: "Full size",
                tenant: "drivalia_it",
                order: 6
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Alfa Romeo Giulia",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 20,
        code: "FFAR",
        carClass: {
            id: 6,
            descr: "Full size",
            carSegment: {
                id: 6,
                descr: "Full size",
                tenant: "drivalia_it",
                order: 6
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Cherokee o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 28,
        code: "FVMR",
        carClass: {
            id: 8,
            descr: "Minibus",
            carSegment: {
                id: 8,
                descr: "Minibus",
                tenant: "drivalia_it",
                order: 8
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiat Talento e similari",
        vehicleType: "VAN",
        maxOverbooking: 0
    },
    {
        id: 22,
        code: "FXAR",
        carClass: {
            id: 6,
            descr: "Full size",
            carSegment: {
                id: 6,
                descr: "Full size",
                tenant: "drivalia_it",
                order: 6
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Alfa Romeo Stelvio",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 14,
        code: "IFAE",
        carClass: {
            id: 4,
            descr: "Intermediate",
            carSegment: {
                id: 4,
                descr: "Intermediate",
                tenant: "drivalia_it",
                order: 4
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "DS3 Crossback Electric o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 13,
        code: "IFAI",
        carClass: {
            id: 4,
            descr: "Intermediate",
            carSegment: {
                id: 4,
                descr: "Intermediate",
                tenant: "drivalia_it",
                order: 4
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Renegade Plug In PHEV o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 12,
        code: "IFML",
        carClass: {
            id: 4,
            descr: "Intermediate",
            carSegment: {
                id: 4,
                descr: "Intermediate",
                tenant: "drivalia_it",
                order: 4
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "DR4",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 11,
        code: "IFMR",
        carClass: {
            id: 4,
            descr: "Intermediate",
            carSegment: {
                id: 4,
                descr: "Intermediate",
                tenant: "drivalia_it",
                order: 4
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Renegade o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 30,
        code: "KGIA",
        carClass: {
            id: 9,
            descr: "Small",
            carSegment: {
                id: 9,
                descr: "LCV",
                tenant: "drivalia_it",
                order: 9
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Doblo",
        vehicleType: "VAN",
        maxOverbooking: 0
    },
    {
        id: 29,
        code: "KMIA",
        carClass: {
            id: 9,
            descr: "Small",
            carSegment: {
                id: 9,
                descr: "LCV",
                tenant: "drivalia_it",
                order: 9
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Fiorino",
        vehicleType: "VAN",
        maxOverbooking: 0
    },
    {
        id: 1,
        code: "MBAE",
        carClass: {
            id: 1,
            descr: "Mini",
            carSegment: {
                id: 1,
                descr: "Mini",
                tenant: "drivalia_it",
                order: 1
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "XVE YO YO e similari",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 24,
        code: "PDAE",
        carClass: {
            id: 7,
            descr: "Premium",
            carSegment: {
                id: 7,
                descr: "Premium",
                tenant: "drivalia_it",
                order: 7
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Tesla - Model Y Lonf Range",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 25,
        code: "PDAR",
        carClass: {
            id: 7,
            descr: "Premium",
            carSegment: {
                id: 7,
                descr: "Premium",
                tenant: "drivalia_it",
                order: 7
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Maserati Ghibli",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 26,
        code: "PFAR",
        carClass: {
            id: 7,
            descr: "Premium",
            carSegment: {
                id: 7,
                descr: "Premium",
                tenant: "drivalia_it",
                order: 7
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Maserati Levante",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 23,
        code: "PXAR",
        carClass: {
            id: 7,
            descr: "Premium",
            carSegment: {
                id: 7,
                descr: "Premium",
                tenant: "drivalia_it",
                order: 7
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Wrangler",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 18,
        code: "SFAE",
        carClass: {
            id: 5,
            descr: "Standard",
            carSegment: {
                id: 5,
                descr: "Standard",
                tenant: "drivalia_it",
                order: 5
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "AIWAYS U5  Prime o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 16,
        code: "SFAI",
        carClass: {
            id: 5,
            descr: "Standard",
            carSegment: {
                id: 5,
                descr: "Standard",
                tenant: "drivalia_it",
                order: 5
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Compass Plug In PHEV o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 17,
        code: "SFML",
        carClass: {
            id: 5,
            descr: "Standard",
            carSegment: {
                id: 5,
                descr: "Standard",
                tenant: "drivalia_it",
                order: 5
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "DR6 o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 15,
        code: "SFMR",
        carClass: {
            id: 5,
            descr: "Standard",
            carSegment: {
                id: 5,
                descr: "Standard",
                tenant: "drivalia_it",
                order: 5
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Jeep Compass o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    },
    {
        id: 32,
        code: "VGIA",
        carClass: {
            id: 9,
            descr: "Small",
            carSegment: {
                id: 9,
                descr: "LCV",
                tenant: "drivalia_it",
                order: 9
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Ducato 35",
        vehicleType: "VAN",
        maxOverbooking: 0
    },
    {
        id: 31,
        code: "VMIA",
        carClass: {
            id: 9,
            descr: "Small",
            carSegment: {
                id: 9,
                descr: "LCV",
                tenant: "drivalia_it",
                order: 9
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Ducato 33",
        vehicleType: "VAN",
        maxOverbooking: 0
    },
    {
        id: 27,
        code: "XFAR",
        carClass: {
            id: 7,
            descr: "Premium",
            carSegment: {
                id: 7,
                descr: "Premium",
                tenant: "drivalia_it",
                order: 7
            },
            tenant: "drivalia_it"
        },
        tenant: "drivalia_it",
        label: "Alfa Romeo Stelvio Quadrifoglio o similare",
        vehicleType: "CAR",
        maxOverbooking: 0
    }
];

export const COMMERCIAL_SEGMENTS: CommercialSegmentEntityResponse[] = [
    {
        "id": "SUB",
        "name": "SUBSCRIPTIONS",
        "active": true,
    },
    {
        "id": "JLR",
        "name": "JLR",
        "active": true,
    },
    {
        "id": "RET",
        "name": "RETAIL",
        "active": true,
    },
    {
        "id": "COR",
        "name": "CORPORATE",
        "active": true,
    },
    {
        "id": "REP",
        "name": "REPLACEMENT",
        "active": true,
    },
    {
        "id": "TOP",
        "name": "TOUR OPERATORS",
        "active": true,
    }
];

export const COMMERCIAL_CATEGORIES: CommercialCategoryEntityResponse[] = [
    {
        "id": "2",
        "name": "Dream Garage",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "78",
        "name": "Prelease Old fino al 2020",
        "commercialSegment": {
            "id": "REP",
            "name": "REPLACEMENT",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "43",
        "name": "Flex",
        "commercialSegment": {
            "id": "RET",
            "name": "RETAIL",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "10",
        "name": "Gruppo FCA",
        "commercialSegment": {
            "id": "COR",
            "name": "CORPORATE",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "4",
        "name": "BE FREE EVO",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "5",
        "name": "PLUG&DRIVE",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "47",
        "name": "Walk-In",
        "commercialSegment": {
            "id": "RET",
            "name": "RETAIL",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "9",
        "name": "Car Box",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "18",
        "name": "CarCloud",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "29",
        "name": "JLR",
        "commercialSegment": {
            "id": "JLR",
            "name": "JLR",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "77",
        "name": "Ecommerce",
        "commercialSegment": {
            "id": "COR",
            "name": "CORPORATE",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "42",
        "name": "Accordi Commerciali",
        "commercialSegment": {
            "id": "COR",
            "name": "CORPORATE",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "24",
        "name": "Assistenze",
        "commercialSegment": {
            "id": "REP",
            "name": "REPLACEMENT",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "33",
        "name": "Tour Operator",
        "commercialSegment": {
            "id": "TOP",
            "name": "TOUR OPERATORS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "22",
        "name": "Prelease New dal 2021",
        "commercialSegment": {
            "id": "COR",
            "name": "CORPORATE",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "3",
        "name": "Flex Rent",
        "commercialSegment": {
            "id": "SUB",
            "name": "SUBSCRIPTIONS",
            "active": true,
        },
        "active": true,
    },
    {
        "id": "84",
        "name": "Tour Operator POA",
        "commercialSegment": {
            "id": "TOP",
            "name": "TOUR OPERATORS",
            "active": true,
        },
        "active": true,
    }
];

export const PRODUCT_CODES: ProductCodeEntityResponse[] = [
    {
        "id": "33",
        "name": "RETAIL POA",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "34",
        "name": "RETAIL PREPAID",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "31",
        "name": "RETAIL POA_1",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "32",
        "name": "RETAIL PREPAID_1",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "28",
        "name": "test",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "27",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "26",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "25",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "23",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "83",
        "name": "Opel Corsa - Nissan",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "22",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "19",
        "name": "aaaaa",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "82",
        "name": "Opel CorsaX",
        "commercialCategory": {
            "id": "9",
            "name": "Car Box",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "18",
        "name": "prova tenants",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "17",
        "name": "MYPRODUCT",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "16",
        "name": "test price",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "15",
        "name": "eweqwdasdsdas",
        "commercialCategory": {
            "id": "2",
            "name": "Dream Garage",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "14",
        "name": "pricing test",
        "commercialCategory": {
            "id": "2",
            "name": "Dream Garage",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "13",
        "name": "test pricing",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "12",
        "name": "PT test",
        "commercialCategory": {
            "id": "24",
            "name": "Assistenze",
            "commercialSegment": {
                "id": "REP",
                "name": "REPLACEMENT",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "11",
        "name": "Panda X",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "3",
        "name": "Opel Corsa con Billing Mode",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "79",
        "name": "Car Cloud Country Club",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "9",
        "name": "NewSpecifics",
        "commercialCategory": {
            "id": "33",
            "name": "Tour Operator",
            "commercialSegment": {
                "id": "TOP",
                "name": "TOUR OPERATORS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "10",
        "name": "New Specifics 2",
        "commercialCategory": {
            "id": "9",
            "name": "Car Box",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "8",
        "name": "string",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "7",
        "name": "string",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "78",
        "name": "Car Cloud Metropolis Style",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "75",
        "name": "Flex Prepaid",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "81",
        "name": "Italy Club TO",
        "commercialCategory": {
            "id": "33",
            "name": "Tour Operator",
            "commercialSegment": {
                "id": "TOP",
                "name": "TOUR OPERATORS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "85",
        "name": "Fiat Ducato",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "80",
        "name": "FCA Standard Class",
        "commercialCategory": {
            "id": "10",
            "name": "Gruppo FCA",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "84",
        "name": "Mepa promo mese 2021",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000023",
        "name": "Opel Corsa - Nissan",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000025",
        "name": "Fiat Ducato",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000022",
        "name": "Opel CorsaX",
        "commercialCategory": {
            "id": "9",
            "name": "Car Box",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000051",
        "name": "RETAIL POA",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000052",
        "name": "RETAIL PREPAID",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000049",
        "name": "RETAIL POA_1",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000050",
        "name": "RETAIL PREPAID_1",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000046",
        "name": "test",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E110900094",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000045",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000044",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E110900093",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000042",
        "name": "BUSINESS ILL -30%",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000039",
        "name": "aaaaa",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000038",
        "name": "prova tenants",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000037",
        "name": "MYPRODUCT",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000036",
        "name": "test price",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000035",
        "name": "eweqwdasdsdas",
        "commercialCategory": {
            "id": "2",
            "name": "Dream Garage",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000034",
        "name": "pricing test",
        "commercialCategory": {
            "id": "2",
            "name": "Dream Garage",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000033",
        "name": "test pricing",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000032",
        "name": "PT test",
        "commercialCategory": {
            "id": "24",
            "name": "Assistenze",
            "commercialSegment": {
                "id": "REP",
                "name": "REPLACEMENT",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000031",
        "name": "Panda X",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000003",
        "name": "Opel Corsa con Billing Mode",
        "commercialCategory": {
            "id": "4",
            "name": "BE FREE EVO",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E110100516",
        "name": "Car Cloud Country Club",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000029",
        "name": "NewSpecifics",
        "commercialCategory": {
            "id": "33",
            "name": "Tour Operator",
            "commercialSegment": {
                "id": "TOP",
                "name": "TOUR OPERATORS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000030",
        "name": "New Specifics 2",
        "commercialCategory": {
            "id": "9",
            "name": "Car Box",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000028",
        "name": "string",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "0000000027",
        "name": "string",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E113301188",
        "name": "Car Cloud Metropolis Style",
        "commercialCategory": {
            "id": "18",
            "name": "CarCloud",
            "commercialSegment": {
                "id": "SUB",
                "name": "SUBSCRIPTIONS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E113300646",
        "name": "Flex Prepaid",
        "commercialCategory": {
            "id": "43",
            "name": "Flex",
            "commercialSegment": {
                "id": "RET",
                "name": "RETAIL",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E113300671",
        "name": "Italy Club TO",
        "commercialCategory": {
            "id": "33",
            "name": "Tour Operator",
            "commercialSegment": {
                "id": "TOP",
                "name": "TOUR OPERATORS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E113871193",
        "name": "FCA Standard Class",
        "commercialCategory": {
            "id": "10",
            "name": "Gruppo FCA",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "E110900110",
        "name": "Mepa promo mese 2021",
        "commercialCategory": {
            "id": "42",
            "name": "Accordi Commerciali",
            "commercialSegment": {
                "id": "COR",
                "name": "CORPORATE",
                "active": true,
            },
            "active": true,
        },
        "active": true
    },
    {
        "id": "prova1    ",
        "name": "Zero Excess",
        "commercialCategory": {
            "id": "33",
            "name": "Tour Operator",
            "commercialSegment": {
                "id": "TOP",
                "name": "TOUR OPERATORS",
                "active": true,
            },
            "active": true,
        },
        "active": true
    }
];

export const SNACKBAR = {
    LOADING: {
        message: "Loading..",
        type: snackbarTypes.loading,
        show: true,
        autoClose: false
    },
    ERROR: {
        message: "Error",
        type: snackbarTypes.error,
        show: true,
        autoClose: true
    },
    SUCCESS: {
        message: "Success",
        type: snackbarTypes.success,
        show: true,
        autoClose: true
    },
    WARNING: {
        message: "Warning",
        type: snackbarTypes.warning,
        show: true,
        autoClose: true
    },
    FORM_ERROR: {
        message: "Sono presenti errori nel form.",
        type: snackbarTypes.error,
        show: true,
        autoClose: true
    }
};

export const SET_SNACKBAR = {
    ERROR: {
        type: setSnackbar,
        payload: {
            snackbar: SNACKBAR.ERROR
        }
    },
    LOADING: {
        type: setSnackbar,
        payload: {
            snackbar: SNACKBAR.LOADING
        }
    },
    SUCCESS: {
        type: setSnackbar,
        payload: {
            snackbar: SNACKBAR.SUCCESS
        }
    },
    FORM_ERROR: {
        type: setSnackbar,
        payload: {
            snackbar: SNACKBAR.FORM_ERROR
        }
    }
};

const COL_DEF = {
    resizable: true,
    suppressMovable: true,
    suppressMenu: true
};

export const DEFAULT_COL_DEF = {
    ...COL_DEF,
    sortable: true,
    editable: false
};
export const DEFAULT_PLAN_COL_DEF = {
    ...COL_DEF,
    sortable: false,
    editable: false
};
export const DEFAULT_MATRIX_COL_DEF = {
    ...COL_DEF,
    sortable: false,
    editable: true,
    wrapHeaderText: true
};

export enum BASE_DEFINITION_FORM_STEPS {
    DEFINITION = 0,
    ASSOCIATION = 1,
    MATRIX = 2,
    DONE = 3,
}

export const COMPETITORS_BENCHMARK_REPORTS = [
    {
        searchDate: "2023-03-06",
        office: "Brindisi Airport (BDS)",
        site: "autoeurope.it",
        date: "2023-04-01",
        days: 15,
        columns: [
            "locauto",
            "enterprise",
            "sixt",
            "noleggiare"
        ],
        rows: [
            {
                "category": "mini",
                "values": [
                    283,
                    365,
                    397,
                    697,
                    293,
                    369,
                    612
                ]
            },
            {
                "category": "economy",
                "values": [
                    485,
                    902,
                    994,
                    1212,
                    1105,
                    2039,
                    2966
                ]
            },
            {
                "category": "compact",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "suv",
                "values": [
                    283,
                    365,
                    397,
                    697,
                    293,
                    369,
                    612
                ]
            },
            {
                "category": "midsize",
                "values": [
                    485,
                    902,
                    994,
                    1212,
                    1105,
                    2039,
                    2966
                ]
            },
            {
                "category": "big",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "standard",
                "values": [
                    283,
                    365,
                    397,
                    697,
                    293,
                    369,
                    612
                ]
            }
        ]
    },
    {
        searchDate: "2023-03-06",
        office: "Brindisi Airport (BDS)",
        site: "autoeurope.it",
        date: "2023-04-01",
        days: 30,
        columns: [
            "locauto",
            "enterprise",
            "sixt",
            "noleggiare"
        ],
        rows: [
            {
                "category": "mini",
                "values": [
                    283,
                    365,
                    397,
                    697,
                    293,
                    369,
                    612
                ]
            },
            {
                "category": "economy",
                "values": [
                    485,
                    902,
                    994,
                    1212,
                    1105,
                    2039,
                    2966
                ]
            },
            {
                "category": "compact",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "suv",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "midsize",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "big",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            },
            {
                "category": "standard",
                "values": [
                    715,
                    3096,
                    2091,
                    3666,
                    5198,
                    6434,
                    8238
                ]
            }
        ]
    }
];

export const PRICING_REPORTS = {
    COMPETITORS_BENCHMARK: "Competitors benchmarks",
    AVERAGE_RPD: "Average revenue per day",
    UTILIZATION_AVAILABILITY: "Utilization and availability data",
    RESERVATIONS_PER_DAY: "Number of days of reservations",
    RESERVATIONS_BOOKING_DATE_AND_CARGROUPS: "Number of reservations for booking date and car groups",
    REVENUES: "Revenues",
    RESERVATIONS_NUMBER: "Number of reservations",
    RPD_INCOMING_RESERVATIONS: "Revenue per day for incoming reservations"
};

const ENUM_ALERTS: EnumInterface = {
    UTILIZATION_AVAILABILITY: "Availability of vehicles in the locations and fleet utilization",
    COMPETITORS_BENCHMARK: "Competitors benchmarks",
    ADVANCE_BOOKING: "Advance booking",
    CAPACITY_UTILIZATION: "Capacity of the locations and fleet utilization",
    PRICING_ERRORS: "Pricing errors",
    RPD_PICKUP_DATE_LOCATION: "Revenue per day for locations and pick-up date"
};

const ENUM_SCHEDULING_TYPE: EnumInterface = {
    WEEKLY: "Weekly",
    DAILY: "Daily",
    MONTHLY: "Monthly"
};

const ENUM_UNIT_TYPE: EnumInterface = {
    MONTH: "Month",
    KM: "Km",
    HOUR: "Hour",
    MINUTE: "Minute",
    RENTAL: "Rental",
    WEEK: "Week",
    DAY: "Day"
};

export const minNumberYupLimit = -20000000;
export const maxNumberYupLimit = 20000000;
export const numberIntegerRegex = /^\d*$/;
export const numberIntegerWithNegativeValuesRegex = /^-?\d*$/;
export const numberRegex = /^\d*[.,]?\d*$/;
export const numberWithNegativeValuesRegex = /^-?\d*[.,]?\d*$/;